module.exports = __webpack_public_path__ + "static/media/Galeri_29.253abf21.jpg";